/**
 * Minimal class-name joiner.
 *
 * Deliberately not `clsx`: the UI layer only ever needs "drop the falsy parts
 * and join with a space", and a dependency for that is not worth the bytes.
 */
export function cn(...parts: Array<string | false | null | undefined>): string {
  let out = '';
  for (const part of parts) {
    if (!part) continue;
    out = out.length === 0 ? part : `${out} ${part}`;
  }
  return out;
}
